import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78895b32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = {
  key: 0,
  class: "row-count"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "total-commission"
}
const _hoisted_5 = {
  key: 2,
  class: "info"
}
const _hoisted_6 = {
  key: 0,
  class: "filter"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 3,
  class: "small-screen-list"
}
const _hoisted_10 = {
  key: 0,
  class: "filter"
}
const _hoisted_11 = ["id"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "button-container" }
const _hoisted_15 = { class: "tooltip" }

import { PropType, computed, onMounted, ref } from "vue";
import { GridFilter } from "@/types/ui/GridFilter";
import DxButton from "devextreme-vue/button";
import GridMenu from "./grid-menu.vue";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import { DxTooltip } from "devextreme-vue/tooltip";
import { ListFilterKeys } from "@/enums/ListFilterKeys";
import { formatNumberIntoCurrency } from "@/utils/CurrencyFormatter";
import { CurrentUser } from "@/types/user/CurrentUser";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'grid-filter-summary',
  props: {
  /**
   * Filters applied to the filter list.
   * @type {GridFilter[]} - An array of objects defining the filter criteria.
   * @required
   */
  filters: {
    type: Array as PropType<GridFilter[]>,
    required: true,
  },
  /**
   * Determines whether the filters should be displayed.
   * @type {boolean}
   * @default true
   */
  displayFilters: {
    type: Boolean,
    default: true,
  },
  /**
   * Determines whether the filters should be disabled.
   * @type {boolean}
   * @default false
   */
  disableFilters: {
    type: Boolean,
    default: false,
  },
  /**
   * The number of rows displayed in the component.
   * @type {number}
   * @required
   */
  rowCount: {
    type: Number,
    required: true,
  },
  /**
   * An array of context menu items.
   * @type {ContextMenuItem[]}
   */
  menuItems: {
    type: Array as PropType<ContextMenuItem[]>,
  },
  /**
   * Determines whether to show generic menu items.
   * @type {boolean}
   * @default true
   */
  showGenericMenuItems: {
    type: Boolean,
    default: true,
  },
  /**
   * Determines whether to show the export item.
   * @type {boolean}
   * @default true
   */
  showExportItem: {
    type: Boolean,
    default: true,
  },
  /**
   * Determines whether to display the 'New' button.
   * @type {boolean}
   * @default false
   */
  displayNewButton: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the 'New' button should be disabled.
   * @type {boolean}
   * @default false
   */
  disableNewButton: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the dropdown menu button should be disabled.
   * @type {boolean}
   * @required
   */
  dropdownMenuDisable: {
    type: Boolean,
    required: true,
  },
  /**
   * The text displayed on the 'New' button.
   * @type {string}
   * @default ''
   */
  newButtonText: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to show the menu button.
   * @type {boolean}
   * @default true
   */
  showMenu: {
    type: Boolean,
    default: true,
  },
  /**
   * Determines whether the header should be dark.
   * @type {boolean}
   * @default true
   */
  darkHeader: {
    type: Boolean,
    default: true,
  },
  /**
   * The ID for the grid menu button.
   * @type {string}
   * @default 'grid-menu-button'
   */
  gridMenuId: {
    type: String,
    default: "grid-menu-button",
  },
  /**
   * The position of the menu button.
   * @type {string}
   * @default 'top right'
   */
  myPosition: {
    type: String,
    default: "top right",
  },
  /**
   * The position of the dropdown menu.
   * @type {string}
   * @default 'bottom right'
   */
  atPosition: {
    type: String,
    default: "bottom right",
  },
  /**
   * Determines whether to show the filter column.
   * @type {boolean}
   * @default false
   */
  showFilterColumn: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the TotalCommission should be displayed.
   * @type {boolean}
   * @default false
   */
  showTotalCommission: {
    type: Boolean,
    default: false,
  },
  /**
   * The number of totalCommission displayed in the component.
   * @type {number}
   * @default: 0
   */
  totalCommission: {
    type: Number,
    default: 0,
  },
  /**
   * Determines whether the row count should be displayed
   * @type {boolean}
   * @default: true
   */
  showRowCount: {
    type: Boolean,
    default: true,
  },
  /** Indicates whether data is currently being refreshed
   * @type {boolean}
   * @default: false
   */
  refreshing: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emitted when filter item is clicked
   * @event filterClick
   */
  "filterClick",
  /**
   * Emitted when a menu item is clicked, passing the clicked item's key.
   * @event menuItemClick
   * @param {string} key - The key of the clicked menu item.
   */
  "menuItemClick",

  /**
   * Emitted when the "new" button is clicked to trigger a new action or record.
   * @event newButtonClicked
   */
  "newButtonClicked",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "6a3152cb": (headerBackgroundColour.value),
  "15ebc04a": (headerTextColour.value),
  "14ff3082": (buttonBorder.value)
}))



const currentUser = ref<CurrentUser>();
const currentUserStore = useCurrentUserStore();
const enableColumnIsShown = ref(false);



onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

/** Handles the filter button click event */
const onFilterClick = () => emit("filterClick");

/** Handles the menu item click event */
const onMenuItemClick = (key: string) => {
  if (key == ListFilterKeys.Enable || key == ListFilterKeys.Disable) {
    enableColumnIsShown.value = !enableColumnIsShown.value;
  }

  // The enable column is displayed when the following two options are selected but only when it's already being hidden.
  if (
    (!enableColumnIsShown.value && key == ListFilterKeys.UnselectAllRows) ||
    (!enableColumnIsShown.value && key == ListFilterKeys.SelectAllRows)
  ) {
    enableColumnIsShown.value = true;
  }

  emit("menuItemClick", key);
};

/** Checks whether all prop filters are empty */
const areAllFiltersEmpty = computed(() => {
  return props.filters.every(
    (filter) => !filter.values || filter.values.length === 0,
  );
});

const newButtonClick = () => {
  emit("newButtonClicked");
};

const menuItems = computed(() => {
  if (!props.showMenu) {
    return [];
  }

  if (!props.showGenericMenuItems) {
    return props.menuItems;
  }

  const compuputedItems: ContextMenuItem[] = [
    {
      text: "Refresh",
      key: "refresh",
      icon: "fas fa-redo",
    },
  ];

  if (props.showExportItem) {
    compuputedItems.push({
      text: "Export to Excel",
      key: "export",
      icon: "fas fa-download",
    });
  }

  if (props.showFilterColumn) {
    compuputedItems.push({
      text: "Filter Rows",
      key: ListFilterKeys.FilterRows,
      icon: "fas fa-regular fa-square-check",
      disabled: false,
      items: [
        {
          text: enableColumnIsShown.value ? "Disable" : "Enable",
          key: enableColumnIsShown.value
            ? ListFilterKeys.Disable
            : ListFilterKeys.Enable,
          icon: enableColumnIsShown.value
            ? "fas fa-regular fa-xmark"
            : "fas fa-regular fa-check",
          disabled: false,
        },
      ],
    });
  }

  if (enableColumnIsShown.value) {
    const index = compuputedItems.findIndex((item) => {
      return item.key == ListFilterKeys.FilterRows;
    });
    compuputedItems[index].items?.push(
      {
        text: "Select All",
        key: ListFilterKeys.SelectAllRows,
        icon: "fas fa-regular fa-square-check",
        disabled: false,
      },
      {
        text: "Unselect All",
        key: ListFilterKeys.UnselectAllRows,
        icon: "fas fa-regular fa-square",
        disabled: false,
      },
    );
  }

  if (props.showFilterColumn && !enableColumnIsShown.value) {
    const index = compuputedItems.findIndex((item) => {
      return item.key == ListFilterKeys.FilterRows;
    });
    if (index) {
      compuputedItems[index].items = compuputedItems[index].items?.splice(0, 2);
    }
  }

  return props.menuItems
    ? props.menuItems.concat(compuputedItems)
    : compuputedItems;
});

const screenWidth = ref(screen.width);

const headerBackgroundColour = computed(() =>
  props.darkHeader ? "#212d53" : "white",
);
const headerTextColour = computed(() =>
  props.darkHeader ? "white" : "#212d53",
);
const buttonBorder = computed(() =>
  props.darkHeader ? "unset" : "1px solid #e0e0e0",
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.showRowCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(props.rowCount), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.showTotalCommission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Total Commission: " + _toDisplayString(_unref(formatNumberIntoCurrency)(
          props.totalCommission,
          currentUser.value?.countryCodeID,
        )), 1))
        : _createCommentVNode("", true),
      (screenWidth.value > 750)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                (filter.values?.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(filter.title) + " : " + _toDisplayString(filter.values.map((item) => item.description).join(", ")), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (areAllFiltersEmpty.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "All"))
              : _createCommentVNode("", true),
            (__props.refreshing)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Refreshing..."))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter, index) => {
              return (_openBlock(), _createElementBlock("span", { key: index }, [
                (filter.values?.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(filter.title) + " ", 1),
                      _createElementVNode("i", {
                        class: "fas fa-info-circle info-icon",
                        id: filter.title.replace(' ', '')
                      }, null, 8, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (areAllFiltersEmpty.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "All"))
              : _createCommentVNode("", true),
            (__props.refreshing)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Refreshing..."))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", _hoisted_14, [
        _renderSlot(_ctx.$slots, "custom-buttons"),
        (props.displayNewButton)
          ? (_openBlock(), _createBlock(_unref(DxButton), {
              key: 0,
              icon: "fas fa-plus",
              onClick: newButtonClick,
              disabled: props.disableNewButton,
              text: __props.newButtonText
            }, null, 8, ["disabled", "text"]))
          : _createCommentVNode("", true),
        (menuItems.value && menuItems.value.length > 0)
          ? (_openBlock(), _createBlock(GridMenu, {
              key: 1,
              "menu-items": menuItems.value,
              onItemClicked: onMenuItemClick,
              disabled: props.dropdownMenuDisable,
              class: "grid-menu-button",
              id: props.gridMenuId,
              atPosition: props.atPosition,
              myPosition: props.myPosition
            }, null, 8, ["menu-items", "disabled", "id", "atPosition", "myPosition"]))
          : _createCommentVNode("", true),
        (props.displayFilters)
          ? (_openBlock(), _createBlock(_unref(DxButton), {
              key: 2,
              icon: "fas fa-filter",
              onClick: onFilterClick,
              disabled: props.disableFilters
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filter, index) => {
      return (_openBlock(), _createBlock(_unref(DxTooltip), {
        key: index,
        target: `#${filter.title.replace(' ', '')}`,
        "show-event": { name: 'mouseenter click' },
        "hide-event": "mouseleave",
        width: "275px",
        "hide-on-outside-click": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.values, (value, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(value.description), 1))
              }), 128))
            ])
          ])
        ]),
        _: 2
      }, 1032, ["target"]))
    }), 128))
  ], 64))
}
}

})